import React from "react";

import { useIntl } from "react-intl";

import Checkbox from "ds/Checkbox";
import useMediaQuery from "Hooks/useMediaQuery";
import { CommonErrorType } from "Reducers/types";

import * as S from "../EnvironmentGeneralSettings.styles";
import EnvironmentSettingsHttpAccess from "../EnvironmentSettingsHttpAccess";

import type { Environment } from "@packages/client";
import type {
  LoginDefault,
  LoginFormTypes
} from "src/organization/pages/project/environment/settings/general/containers/EnvironmentGeneralSettings/types";

interface Props {
  basicAuth?: LoginDefault[];
  environment: Environment;
  errors?: CommonErrorType;
  ipText: string | string[];
  isEnabled: boolean;
  onHttpAccessControlChange: (checked: boolean) => void;
  onIpTextAreaChange: (e: React.ChangeEvent) => void;
  onLoginsChangeHandler: (
    newValue: string,
    field: LoginFormTypes,
    index: number
  ) => void;
  onLoginAddHandler: () => void;
  removeLineHandler: (index: number) => void;
  projectId: string;
  checkLoginsValidation: (field: LoginFormTypes, index: number) => void;
}

const HttpAccessSetting = ({
  basicAuth,
  environment,
  errors,
  ipText,
  isEnabled,
  onHttpAccessControlChange,
  onIpTextAreaChange,
  onLoginsChangeHandler,
  onLoginAddHandler,
  removeLineHandler,
  projectId,
  checkLoginsValidation
}: Props) => {
  const intl = useIntl();

  const onMobile = useMediaQuery("(max-width: 768px)");
  return (
    <>
      <S.SettingWrapper>
        <Checkbox
          disabled={!environment?.hasPermission("#edit")}
          label={intl.formatMessage<React.ReactNode>(
            {
              id: onMobile ? "is_controlled.title" : "is_controlled"
            },
            {
              b: chunks => <strong>{chunks}</strong>
            }
          )}
          checked={isEnabled}
          onCheckedChanged={onHttpAccessControlChange}
          forId="environment-is-controlled-switch"
          id={onMobile ? "is_controlled.title" : "is_controlled"}
        />{" "}
        {onMobile && (
          <S.HttpsBodyText>
            {intl.formatMessage({ id: "is_controlled.description" })}
          </S.HttpsBodyText>
        )}
      </S.SettingWrapper>
      {isEnabled && (
        <>
          <EnvironmentSettingsHttpAccess
            errors={errors}
            environment={environment}
            projectId={projectId}
            basicAuth={basicAuth}
            ipText={ipText}
            onLoginsChangeHandler={onLoginsChangeHandler}
            onLoginAddHandler={onLoginAddHandler}
            removeLineHandler={removeLineHandler}
            onIpTextAreaChange={onIpTextAreaChange}
            checkLoginsValidation={checkLoginsValidation}
          />
        </>
      )}
    </>
  );
};

export default HttpAccessSetting;
